import classNames from 'classnames';
import React from 'react';

import { useMediaQuery } from '../../hooks/useMediaQuery';

interface DialogContainerProps {
  // eslint-disable-next-line react/no-unused-prop-types
  centered?: boolean;
}

export const DialogContainer: React.FC<
  React.PropsWithChildren<DialogContainerProps>
> = ({ children }) => {
  const largerThanMobile = useMediaQuery('md');

  return (
    <div
      className={classNames(
        'dialog-container relative mx-auto flex w-full flex-col overflow-y-scroll rounded-t-lg bg-white outline-0 no-scrollbar md:max-w-md md:rounded-lg',
        { 'dialog-container-desktop': largerThanMobile },
      )}
    >
      {children}
    </div>
  );
};
